import { render, staticRenderFns } from "./ManagementContactsPage.vue?vue&type=template&id=10612f75"
import script from "./ManagementContactsPage.vue?vue&type=script&lang=js"
export * from "./ManagementContactsPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementContactsPage.vue?vue&type=style&index=0&id=10612f75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports